import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@store/hooks';
import {
  setActiveDateClass,
  setDashboardChartQuery,
  setDefaultValuesForCharts,
  setSelectedDateIDForChart,
} from '@store/slices/global/global';

export const useResetReportingFiltersOnExit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const wasOnReportingRef = useRef(false);

  useEffect(() => {
    const isOnReporting = location.pathname.startsWith('/reporting');

    if (wasOnReportingRef.current && !isOnReporting) {
      dispatch(setDashboardChartQuery({ range: 'today' }));
      dispatch(setDefaultValuesForCharts({} as any));
      dispatch(setSelectedDateIDForChart(0));
      dispatch(setActiveDateClass(' active'));
    }

    wasOnReportingRef.current = isOnReporting;
  }, [location, dispatch]);
};
